/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Input, ElementRef, Renderer, ViewEncapsulation, HostBinding } from '@angular/core';
import classNames from 'classnames';
export class ButtonGroup {
/**
 * 设置按钮大小。可选值为`large`, `small`, `default`，默认取值为`default`
 */
size: string;
/**
 * 样式前缀
 */
prefixCls = 'ant-btn-group';
/**
 * 用户CSS样式
 */
class: string;
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 */
constructor(private _renderer: Renderer,
private _elementRef: ElementRef) {

    }
/**
 * 最终样式
 * @return {?}
 */
get classes(): string {
        return this.getClassNames();
    }
/**
 * @return {?}
 */
protected getClassNames(): string {
        const /** @type {?} */ classes = classNames(this.prefixCls, {
            [`${this.prefixCls}-${this.sizeCls}`]: this.sizeCls
        }, this.class);
        return classes;
    }
/**
 * @return {?}
 */
get sizeCls(): string {
        // large => lg
        // small => sm
        return ( /** @type {?} */((<any>{
            'large': 'lg',
            'small': 'sm'
        })))[this.size] || '';
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-button-group',
    template: `<ng-content></ng-content>`,
    styleUrls: ['./style/button.group.scss'],
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'size': [{ type: Input },],
'prefixCls': [{ type: Input },],
'class': [{ type: Input },],
'classes': [{ type: HostBinding, args: ['class', ] },],
};
}

function ButtonGroup_tsickle_Closure_declarations() {
/** @type {?} */
ButtonGroup.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ButtonGroup.ctorParameters;
/** @type {?} */
ButtonGroup.propDecorators;
/**
 * 设置按钮大小。可选值为`large`, `small`, `default`，默认取值为`default`
 * @type {?}
 */
ButtonGroup.prototype.size;
/**
 * 样式前缀
 * @type {?}
 */
ButtonGroup.prototype.prefixCls;
/**
 * 用户CSS样式
 * @type {?}
 */
ButtonGroup.prototype.class;
/** @type {?} */
ButtonGroup.prototype._renderer;
/** @type {?} */
ButtonGroup.prototype._elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
